import { useState } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import NoAccountHint from '../components/NoAccountHint';

export default function Login() {
  const [params] = useSearchParams();
  const next = params.get('next');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const [showHint, setShowHint] = useState(false);
  const navigate = useNavigate();
  const notice = useLocation().state?.notice;

  async function submit(e) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error === 'account_locked'
          ? 'Too many failed attempts. Try again in 30 minutes.'
          : 'Invalid email or password.');
        setShowHint(true);
        return;
      }
      localStorage.setItem('learnable_user', JSON.stringify(data.user));
      navigate(next || (data.user.is_admin ? '/admin' : '/dashboard'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={submit} className="max-w-sm mx-auto px-4 py-12 space-y-4">
      <h1 className="text-2xl font-bold">Log in</h1>
      {notice && (
        <div role="status" className="text-sm text-slate-700 bg-amber-50 border border-amber-200 rounded px-3 py-2">
          {notice}
        </div>
      )}
      <input
        type="email"
        required
        placeholder="Email"
        className="w-full border rounded px-3 py-2"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        type="password"
        required
        placeholder="Password"
        className="w-full border rounded px-3 py-2"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      {error && <div className="text-sm text-red-600">{error}</div>}
      {showHint && <NoAccountHint />}
      <button
        disabled={busy}
        className="w-full bg-brand text-white rounded py-2 font-medium disabled:opacity-50"
      >
        {busy ? 'Signing in…' : 'Log in'}
      </button>
      <div className="flex items-center justify-between text-sm pt-2">
        <Link to="/forgot-password" className="text-slate-500 hover:text-brand">Forgot password?</Link>
        <Link to="/signup" className="text-slate-500 hover:text-brand">Create account</Link>
      </div>
    </form>
  );
}
